export function getSharedArray<T, K extends keyof T>(fields: T | undefined, fieldName: K): T[K] {
  const field = fields?.[fieldName];
  const sharedString = `${fieldName as string}Shared` as keyof T;
  const sharedField = fields?.[sharedString] as T[K];

  if (Array.isArray(field) && field.length > 0) {
    return field;
  } else if (sharedField) {
    return sharedField;
  } else {
    return [] as T[K];
  }
}
